// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';

// Atoms
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

// Styles
import styles from './styles';

@withStyles(styles)
export default class ScrollFormSection extends Component {
  static propTypes = {
    canSubmit: PropTypes.func,
    children: PropTypes.any,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    index: PropTypes.number,
    nodeRef: PropTypes.any,
    onActivation: PropTypes.func,
    onSubmit: PropTypes.func,
    onSkip: PropTypes.func,
    buttons: PropTypes.any,
    hideNextButton: PropTypes.bool,
    withSkipButton: PropTypes.bool,
    title: PropTypes.any,
    onOverlayClick: PropTypes.func,
    hasValidationError: PropTypes.bool, // eslint-disable-line
  };

  static defaultProps = {
    canSubmit: () => true,
    onActivation: () => {},
    onSubmit: () => {},
    onSkip: () => {},
    onOverlayClick: () => {},
  };

  componentDidMount() {
    if (!this.props.disabled) {
      this.props.onActivation();
    }
  }

  componentWillReceiveProps({ disabled, onActivation }) {
    if (!disabled && disabled !== this.props.disabled) {
      onActivation();
    }
  }

  handleSkipClick = () => {
    this.props.onSkip();
  };

  handleSubmit = (ev) => {
    ev.preventDefault();
    if (this.props.canSubmit()) {
      this.props.onSubmit();
    }
  };

  render() {
    const { classes, children, disabled, nodeRef, title, buttons,
      index, hideNextButton, withSkipButton, onOverlayClick } = this.props;

    return (
      <div
        className={classNames(classes.root, {
          [classes.rootDisabled]: disabled
        })}
        ref={nodeRef}
      >
        { disabled &&
          <div
            tabIndex="-1"
            role="button"
            className={classes.disabledOverlay}
            onClick={onOverlayClick}
          />
        }

        <form onSubmit={this.handleSubmit}>
          <div className={classes.title}>
            <Typography type="body2" className={classes.titleIndex} color="accent">
              { index + 1 } →
            </Typography>
            <Typography type="display1" className={classes.titleLabel}>
              { title }
            </Typography>
          </div>

          <div className={classes.children}>
            { children }
          </div>

          { buttons ||
            <div>
              { withSkipButton &&
                <Button
                  raised
                  onClick={this.handleSkipClick}
                  className={classNames(classes.skipButton, classes.button, {
                    [classes.buttonHidden]: disabled
                  })}
                >
                  Skip
                </Button>
              }

              <Button
                raised
                type="submit"
                color="primary"
                className={classNames(classes.button, {
                  [classes.buttonHidden]: disabled || hideNextButton
                })}
              >
                Next
              </Button>
            </div>
          }
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollForm/Section/index.js